// src/auth/AuthLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import { motion } from "framer-motion";
import styles from "./AuthLayout.module.css";

export default function AuthLayout() {
  return (
    <div className={styles.container}>
      {/* Lateral izquierdo – código decorativo */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className={styles.leftPanel}
      >
        <pre className={styles.codeArt}>
{`// Ezequiel Bamio
const dev = {
  name: "Ezequiel",
  role: "Full Stack Developer",
  stack: ["Java", "Spring Boot", "React"],
  passion: "Crear cosas que impacten",
  available: true
};

// 2025 – Argentina
console.log("Listo para tu proyecto 🚀");`}
        </pre>
        <div className={styles.glow} />
      </motion.div>

      {/* Formulario centrado */}
      <div className={styles.rightPanel}>
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className={styles.formCard}
        >
          <Outlet />
        </motion.div>
      </div>
    </div>
  );
}